import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  // 单词类
  "登录": "登录",
  "公司": "公司",
  "主页": "主页",
  "设定": "设定",
  "努力加载中":"努力加载中",
  "全部":"全部",
  "":"",



  // element多语言
  ...zhLocale
}

export default cn
